import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BehaviorSubject, catchError, filter, Observable, take, throwError} from 'rxjs';
import {Merchant, MerchantQuery} from 'src/app/dashboard/model/merchant-guid';
import {AzureAuthService} from 'src/infrastructure/services/azure-auth.service';

@Injectable({
    providedIn: 'root',
})

export class MerchantsService {
    private readonly _merchants = new BehaviorSubject<Merchant[]>([]);
    private readonly _isInitialized = new BehaviorSubject<boolean>(false);

    public get merchants$(): Observable<Merchant[]> {
        return this._merchants.asObservable();
    }

    public get isInitialized$(): Observable<boolean> {
        return this._isInitialized.asObservable();
    }

    constructor(
        private http: HttpClient,
        private azureAuthService: AzureAuthService
    ) {
        this.azureAuthService.isTokenReady$
        .pipe(filter(r => r), take(1))
        .subscribe(() => this.init());
    }

    public init(): void {
        if (this.azureAuthService.checkUserAzureTokenHasAnyRole() && !this._isInitialized.value) {
            this.loadMerchants();
        }
    }

    private loadMerchants(params?: MerchantQuery): void {
        this.http.get<Merchant[]>('dbov2/merchant/search', { params: { ...params } })
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    this._isInitialized.next(false);
                    return throwError(() => new Error(error?.message || 'Merchants data error'));
                })
            )
            .subscribe((data) => {
                this._merchants.next(data);
                this._isInitialized.next(true);
            });
    }

    public getMerchantsData(forceRefresh = false, params?: MerchantQuery): Observable<Merchant[]>
    {
        if (!this._isInitialized.value || forceRefresh) {
            this.loadMerchants(params);
        }
        return this._merchants.asObservable();
    }
}
